import { ThemeEvents } from '@theme/events';
import { Component } from '@theme/component';

/**
 * Updates the configuration summary block when variants change.
 *
 * This mirrors the pattern used by product-price: we replace the block's
 * rendered HTML with the updated version coming from the variant update response.
 */
class ConfigurationSummary extends Component {
  connectedCallback() {
    super.connectedCallback();
    const closestSection = this.closest('.shopify-section, dialog');
    if (!closestSection) return;
    closestSection.addEventListener(ThemeEvents.variantUpdate, this.updateSummary);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    const closestSection = this.closest('.shopify-section, dialog');
    if (!closestSection) return;
    closestSection.removeEventListener(ThemeEvents.variantUpdate, this.updateSummary);
  }

  /**
   * @param {import('@theme/events').VariantUpdateEvent} event
   */
  updateSummary = (event) => {
    if (event.detail.data.newProduct) {
      this.dataset.productId = event.detail.data.newProduct.id;
    } else if (event.target instanceof HTMLElement && event.target.dataset.productId !== this.dataset.productId) {
      return;
    }

    const newSummary = event.detail.data.html.querySelector(
      `configuration-summary[data-block-id="${this.dataset.blockId}"]`
    );
    if (!newSummary) return;

    // Replace the card contents to preserve this element + listeners
    const currentCard = this.querySelector('[ref="card"]');
    const newCard = newSummary.querySelector('[ref="card"]');
    if (currentCard && newCard) {
      currentCard.replaceWith(newCard);
    }
  };
}

if (!customElements.get('configuration-summary')) {
  customElements.define('configuration-summary', ConfigurationSummary);
}